export default "__VITE_ASSET__CYSD2kow__"